/* FarpointAstro nav clamp - keep header dropdown panels inside the viewport.
   Covers three cases:
   1. Mega menus (multi-column) - centered on trigger by default.
   2. Regular dropdowns (single-column, e.g. Dovetails & Saddles,
      Utilities & Learning) - left-aligned to trigger by default.
   3. Third-level fly-outs (e.g. Losmandy / Vixen submenus) - open to the
      RIGHT of their parent panel by default; when that would run off the
      right edge they flip to open on the LEFT instead.
   Cases 1-2 keep their natural alignment until it would push them off a
   screen edge, then slide just enough to stay fully visible (10px gutter).
   Pure runtime measurement, so it adapts to wherever the [ROW BREAK] split
   control places items, and it re-solves on resize. */
(function () {
  var GUTTER = 10;
  var SEL_ITEM = '.site-nav--has-dropdown';
  var SEL_PANEL = '.site-nav__dropdown';
  var SEL_TRIGGER = '.site-nav__deep-dropdown-trigger';
  var SEL_FLYOUT = '.site-nav__deep-dropdown';

  // Cases 1 & 2: top-level panel stays within the viewport horizontally.
  function positionPanel(item) {
    var panel = item.querySelector(SEL_PANEL);
    if (!panel) return;

    panel.style.removeProperty('left');
    panel.style.removeProperty('right');
    panel.style.removeProperty('transform');

    var vw = document.documentElement.clientWidth;
    var rect = panel.getBoundingClientRect();
    var pw = rect.width;
    if (!pw) return;

    var naturalLeft = rect.left;
    var desiredLeft = Math.max(GUTTER, Math.min(naturalLeft, vw - pw - GUTTER));
    if (Math.abs(desiredLeft - naturalLeft) < 0.5) return;

    var op = panel.offsetParent || item;
    var opRect = op.getBoundingClientRect();
    var opBorderLeft = parseFloat(getComputedStyle(op).borderLeftWidth) || 0;
    var newLeft = desiredLeft - opRect.left - opBorderLeft;

    panel.style.setProperty('left', newLeft + 'px', 'important');
    panel.style.setProperty('right', 'auto', 'important');
    panel.style.setProperty('transform', 'none', 'important');
  }

  // Case 3: third-level fly-out. Default opens right; flip left on overflow.
  function positionFlyout(trigger) {
    var fly = trigger.querySelector(SEL_FLYOUT);
    if (!fly) return;

    fly.style.removeProperty('left');
    fly.style.removeProperty('right');

    var vw = document.documentElement.clientWidth;
    var rect = fly.getBoundingClientRect();
    var fw = rect.width;
    if (!fw) return; // not visible yet

    if (rect.right <= vw - GUTTER) return; // fits as-is (opens right)

    var tRect = trigger.getBoundingClientRect();
    if (tRect.left - fw >= GUTTER) {
      // room to open on the left of the parent column: flip
      fly.style.setProperty('left', 'auto', 'important');
      fly.style.setProperty('right', '100%', 'important');
    } else {
      // no room either side: clamp the right-opening fly-out into the viewport
      var op = fly.offsetParent || trigger;
      var opRect = op.getBoundingClientRect();
      var desiredLeft = Math.max(GUTTER, vw - fw - GUTTER);
      fly.style.setProperty('left', (desiredLeft - opRect.left) + 'px', 'important');
      fly.style.setProperty('right', 'auto', 'important');
    }
  }

  function onEnter(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest(SEL_ITEM);
    if (item) requestAnimationFrame(function () { positionPanel(item); });
    var trigger = t.closest(SEL_TRIGGER);
    if (trigger) requestAnimationFrame(function () { positionFlyout(trigger); });
  }

  document.addEventListener('mouseover', onEnter, true);
  document.addEventListener('focusin', onEnter, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll(SEL_ITEM).forEach(function (item) {
        var d = item.querySelector('details');
        if (d && d.hasAttribute('open')) positionPanel(item);
      });
      document.querySelectorAll(SEL_TRIGGER).forEach(function (trigger) {
        positionFlyout(trigger);
      });
    }, 150);
  });
})();
